export default "__VITE_ASSET__de0efce9__"